import { useMutation, useQueryClient } from "@tanstack/react-query";

import { axios } from "@/client/libs/axios";

export type OptimizeResumeResponse = {
  queueName: string;
};

type QuestionAnswers = Record<string, string>;

export const optimizeResume = async (data: { 
  id: string; 
  answers?: QuestionAnswers;
  focusedMetrics?: string[];
}) => {
  const response = await axios.post<OptimizeResumeResponse>(`/resume-optimizer/optimize/${data.id}`, {
    answers: data.answers || {},
    focusedMetrics: data.focusedMetrics,
  });
  return response.data;
};

export const useOptimizeResume = () => {
  const queryClient = useQueryClient();

  const {
    error,
    isPending: loading,
    mutateAsync: optimizeResumeFn,
  } = useMutation({
    mutationFn: optimizeResume,
    onSuccess: (data) => {
      // Invalidate the optimization queue status after starting optimization
      queryClient.invalidateQueries({ queryKey: ["resume-optimizer-queue"] });
    },
  });

  return { optimizeResume: optimizeResumeFn, loading, error };
};
